import React from 'react';
import css from './WhySection.module.css';

const WhySection = () => {
  const boxesContent = [
    {
      title: 'No Gatekeeping. No Exclusivity.',
      description: 'Upload when you want, keep full rights, and still share elsewhere.',
    },
    {
      title: 'Fair Revenue Split.',
      description: "Creators earn 70% of every paid download. That's it. No hidden fees.",
    },
    {
      title: 'Licensing Your Way.',
      description: 'Pick how your scans can be used: commercial, personal, remixable—your call.',
    },
    {
      title: 'Supports All Major 3d Formats.',
      description:
        "Whether you scan with a phone or a professional X-Grids scanner, you're welcome here.",
    },
    {
      title: 'Your Own Public Profile.',
      description: 'Showcase your work, link out to your portfolio, and build your brand.',
    },
  ];
  return (
    <div className={css.wrapper}>
      <p className={css.title}>Why create on ScanWow?</p>
      <p className={css.description}>
        Whether you're scanning cities, textures or cultural artefacts, this is your space to share
        what
        <br /> you've captured and turn it into something bigger.
      </p>

      <div className={css.line}></div>

      {boxesContent.map((box) => (
        <div className={css.box}>
          <p className={css.boxTitle}>{box.title}</p>
          <p className={css.boxDescription}>{box.description}</p>
        </div>
      ))}
    </div>
  );
};

export default WhySection;
